// extracted by css-extract-rspack-plugin
export default {"cls1":"CiterightInline-cls1_ZF1","cls2":"CiterightInline-cls2_cVF CiterightInline-cls1_ZF1"};